<section class="team-view-page">
  <a class="back-link" routerLink="/dashboard/championship">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
    <span>К списку чемпионатов</span>
  </a>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading-state" *ngIf="loading">Загрузка чемпионата...</div>

  <ng-container *ngIf="championship && !loading">
    <div class="team-view-grid">
      <aside class="team-sidebar">
        <section class="profile-card">
          <span class="team-logo" [style.background-image]="getLogoBackground()">{{ championship.logoUrl ? '' : championship.name.charAt(0) }}</span>
          <h1>{{ championship.name }}</h1>
          <div class="contact-actions">
            <a [href]="championship.websiteUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!championship.websiteUrl" title="Сайт" aria-label="Сайт">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18"/><path d="M12 3a14 14 0 0 0 0 18"/></svg>
            </a>
            <a [href]="championship.telegramUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!championship.telegramUrl" title="Telegram" aria-label="Telegram">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.5 4.5 3 11.8l7 2.2 2.2 7 9.3-16.5Z"/><path d="m10 14 4-4"/></svg>
            </a>
            <a [href]="championship.vkUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!championship.vkUrl" title="ВКонтакте" aria-label="ВКонтакте">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7c.2 8 4.2 11 8 11h1v-4.2c2.5.3 4.4 2 5.2 4.2H22c-1-2.8-2.7-4.6-4.4-5.3 1.7-1 3.1-2.8 3.7-5.7h-3.2c-.8 2.4-2.5 4.2-5.1 4.4V7H9.8v7.7C7.2 14.1 5.5 12.1 5.3 7Z"/></svg>
            </a>
          </div>
          <a class="primary-link" [routerLink]="['/dashboard/championship', championship.slug || championship.id, 'edit']">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
            <span>Редактировать</span>
          </a>
          <button class="danger-link" type="button" (click)="deleteChampionship()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
            <span>Удалить чемпионат</span>
          </button>
        </section>

        <section class="info-card">
          <h2>Детали</h2>
          <dl>
            <div><dt>Команды</dt><dd>{{ championship.teamsTotal }}</dd></div>
            <div><dt>Добавлен</dt><dd>{{ formatDate(championship.createdAt) }}</dd></div>
            <div><dt>Изменен</dt><dd>{{ formatDate(championship.updatedAt) }}</dd></div>
          </dl>
        </section>
      </aside>

      <main class="team-content">
        <section class="info-card analytics-card">
          <div class="card-heading"><div><h2>Статистика</h2><span>Продажи по всем событиям чемпионата.</span></div></div>
          <div class="metrics-grid">
            <article><span>Событий</span><strong>{{ championship.events.length }}</strong></article>
            <article><span>Команд</span><strong>{{ championship.teamsTotal }}</strong></article>
            <article><span>Билетов продано</span><strong>{{ soldTicketsTotal }}</strong></article>
            <article><span>Выручка</span><strong>{{ formatMoney(revenueTotal) }}</strong></article>
          </div>
        </section>

        <section class="info-card">
          <div class="card-heading"><div><h2>Статистика по сезонам</h2><span>Продажи, закупка и выручка в разрезе этапов.</span></div></div>
          <div class="season-stats" *ngIf="championship.seasonStats.length; else noSeasonStats">
            <article *ngFor="let stat of championship.seasonStats">
              <header>
                <div>
                  <h3>{{ stat.name }}</h3>
                  <span>{{ stat.seasonYear || 'Период не указан' }}</span>
                </div>
                <b [class]="'season-type type-' + stat.type">{{ getSeasonTypeName(stat.type) }}</b>
              </header>
              <div class="season-metrics">
                <span>Матчи<strong>{{ stat.eventsTotal }}</strong></span>
                <span>Продано<strong>{{ stat.soldTicketsTotal }}</strong></span>
                <span>Закупка<strong>{{ formatMoney(stat.purchaseTotal) }}</strong></span>
                <span>Выручка<strong>{{ formatMoney(stat.revenueTotal) }}</strong></span>
              </div>
              <div class="playoff-stages" *ngIf="stat.playoffStages.length">
                <span *ngFor="let stage of stat.playoffStages">{{ getPlayoffStageName(stage.stage) }}: {{ stage.eventsTotal }} матч.</span>
              </div>
            </article>
          </div>
          <ng-template #noSeasonStats><p class="muted">События по сезонам пока не добавлены.</p></ng-template>
        </section>

        <section class="info-card">
          <h2>Эффективные матчи</h2>
          <div class="best-events">
            <article><span>По количеству билетов</span><ng-container *ngIf="mostTicketsEvent as ticketsEvent; else noTicketsEvent"><strong>{{ getEventName(ticketsEvent) }}</strong><small>{{ ticketsEvent.soldTicketsTotal }} билетов</small></ng-container></article>
            <article><span>По выручке</span><ng-container *ngIf="mostRevenueEvent as revenueEvent; else noRevenueEvent"><strong>{{ getEventName(revenueEvent) }}</strong><small>{{ formatMoney(revenueEvent.soldRevenue) }}</small></ng-container></article>
          </div>
          <ng-template #noTicketsEvent><strong>Событий пока нет</strong></ng-template>
          <ng-template #noRevenueEvent><strong>Событий пока нет</strong></ng-template>
        </section>

        <section class="info-card">
          <div class="card-heading"><div><h2>События чемпионата</h2><span>История матчей и продаж.</span></div></div>
          <div class="events-list" *ngIf="championship.events.length > 0; else noEvents">
            <a class="event-row" *ngFor="let event of championship.events" [routerLink]="['/dashboard/events', event.slug || event.id]">
              <div><strong>{{ getEventName(event) }}</strong><span>{{ formatDate(event.startsAt) }} · {{ event.seasonName }}</span></div>
              <div class="event-values"><strong>{{ event.soldTicketsTotal }} билетов</strong><span>{{ formatMoney(event.soldRevenue) }}</span></div>
            </a>
          </div>
          <ng-template #noEvents><p class="muted">Для этого чемпионата пока нет событий.</p></ng-template>
        </section>
      </main>
    </div>
  </ng-container>
</section>
